import { render, staticRenderFns } from "./LicencePlate.vue?vue&type=template&id=cc5f847e&scoped=true&"
import script from "./LicencePlate.vue?vue&type=script&lang=js&"
export * from "./LicencePlate.vue?vue&type=script&lang=js&"
import style0 from "./LicencePlate.vue?vue&type=style&index=0&id=cc5f847e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5f847e",
  null
  
)

export default component.exports